<template>
  <div class="index" @click="h5show = false">
    <div class="two-big-title"></div>
    <div class="index-con">
      <div class="big-title">
        <span> Program </span>
      </div>
      <div class="show">
        <img src="../assets/1726646697427.jpg" alt="" width="800px" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      h5show: false,
    };
  },
  methods: {},
};
</script>

<style scoped lang="less">
.show {
  text-align: center;
  padding-bottom: 50px;
}

.index {
  .index-con {
    min-height: 500px;
  }

  .bottom_span {
    height: 2px;
    background: #28d6ec;
    width: 100%;
    margin-bottom: 100px;
    margin-top: 60px;
  }

  .lists {
    .text {
      font-size: 14px;
      margin-bottom: 40px;
      margin-top: 20px;
      font-weight: 500;
      line-height: 1.8;
    }

    .list {
      margin-top: 20px;
      width: 100%;
    }

    .name {
      font-weight: 600;
      text-align: center;
      margin-bottom: 5px;
    }

    .pic {
      width: 140px;
      display: block;
      margin: 0 auto 10px;
    }
  }

  .index-con {
    max-width: 1200px;
    margin: 0 auto;
  }

  .my-title {
    color: #28d6ec;
    font-size: 18px;
    margin: 40px 0;
    font-weight: 500;
  }
}

@media screen and (max-width: 768px) {
  .show img {
    width: 100%;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/program.vue